/* tslint:disable */
import { ViewChaining_parent } from './view-chaining-_parent';

/**
 */
export class ViewChaining {
    studyName?: string;
    parent?: ViewChaining_parent;
    children?: ViewChaining_parent[];
    packingPreventChildComp?: boolean;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-chaining.ts